import { useEffect } from 'react'

import Card from '@/components/Form/Card'
import Image from 'next/image'

import useMultiFileUpload from './MultiFileUpload.hook'
import { MultiFileUploadProps } from './MultiFileUpload.type'

const MultiFileUpload = ({ children, title, onFiles, loading }: MultiFileUploadProps) => {
  const { files, errors, message, handleRemoveFile, handleFileChange } = useMultiFileUpload()

  useEffect(() => {
    if (files) onFiles(files)
  }, [files])

  return (
    <Card title={title}>
      {children}
      <div className="w-full space-y-4">
        <div>
          <label
            htmlFor="fileInput"
            className="btn-primaty btn btn-success btn-md btn-block text-white"
            //eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            disabled={loading}
          >
            Selecione os Arquivos
          </label>
          <input
            id="fileInput"
            type="file"
            multiple
            onChange={handleFileChange}
            accept=".jpeg,.png,.jpg,application/pdf"
            className="hidden"
          />
        </div>

        {/* Lista de arquivos */}
        <ul className="w-full space-y-2">
          {files.map((file, index) => (
            <li
              key={index}
              className="flex items-center justify-between rounded-lg border border-gray-300 p-2"
            >
              {/* Thumbnail */}
              <div className="flex items-center">
                {file.type.startsWith('image/') ? (
                  <Image
                    className="mr-4 h-12 w-12 rounded object-cover"
                    src={URL.createObjectURL(file)}
                    alt={file.name}
                    width={100}
                    height={100}
                  />
                ) : (
                  <div className="mr-4 flex h-12 w-12 items-center justify-center rounded bg-gray-200 text-sm text-gray-500">
                    {file.name.split('.').pop()?.toUpperCase()}
                  </div>
                )}
                <span className="max-w-xs truncate text-sm text-gray-700">{file.name}</span>
              </div>

              {/* Botão de Remover */}
              <button
                type="button"
                onClick={() => handleRemoveFile(index)}
                className="btn btn-error btn-xs text-white"
                disabled={loading}
              >
                Remover
              </button>
            </li>
          ))}
        </ul>

        {errors.length > 0 && (
          <div className="mb-4 text-red-500">
            {errors.map((err, index) => (
              <p key={index}>
                {err.name}: {err.error}
              </p>
            ))}
          </div>
        )}
      </div>
      {message && <p className="mt-4 text-sm text-gray-700">{message}</p>}
    </Card>
  )
}

export default MultiFileUpload
